// import React, { useState } from "react";
// import { useDropzone } from "react-dropzone";

// const Dropzone = ({ onFileDrop, setError, clearErrors, uploadFile, fieldName, fileSize, fileName }) => {
// 	const FILE_SIZE = fileSize ? fileSize * 1000 : 5242880; // 5MB
// 	const SUPPORTED_FORMATS_VIDEO = { "video/mp4": [], "video/x-m4v": [], "video/*": [] };
// 	const SUPPORTED_FORMATS_AUDIO = { "audio/mpeg": [], "audio/wav": [], "audio/mp3": [] };
// 	const SUPPORTED_FORMATS_IMAGE = { "image/jpg": [], "image/jpeg": [], "image/gif": [], "image/png": [] };

// 	const [previewUrl, setPreviewUrl] = useState(null);

// 	const getAcceptedFileTypes = () => {
// 		switch (uploadFile) {
// 			case "image":
// 				return SUPPORTED_FORMATS_IMAGE;
// 			case "video":
// 				return SUPPORTED_FORMATS_VIDEO;
// 			case "audio":
// 				return SUPPORTED_FORMATS_AUDIO;
// 			default:
// 				return [];
// 		}
// 	};

// 	const onDrop = (acceptedFiles) => {
// 		if (acceptedFiles.length > 0) {
// 			const file = acceptedFiles[0];
// 			onFileDrop(file, uploadFile);

// 			clearErrors(fieldName);

// 			const objectUrl = URL.createObjectURL(file);
// 			setPreviewUrl(objectUrl);
// 		}
// 	};

// 	const onDropRejected = (fileRejections) => {
// 		const error = fileRejections[0].errors[0];

// 		if (error.code === "file-too-large") {
// 			setError(fieldName, {
// 				type: "manual",
// 				message: fileSize ? `File is larger than ${fileSize}KB.` : `File is larger than ${FILE_SIZE / 1000000}MB.`,
// 			});
// 		} else if (error.code === "file-invalid-type") {
// 			setError(fieldName, {
// 				type: "manual",
// 				message: error.message + ".",
// 			});
// 		}
// 	};

// 	const { getRootProps, getInputProps } = useDropzone({
// 		onDrop,
// 		onDropRejected,
// 		accept: getAcceptedFileTypes(),
// 		maxSize: FILE_SIZE,
// 		multiple: false,
// 	});

// 	return (
// 		<div
// 			{...getRootProps()}
// 			style={{ border: "2px solid #e0e6f7", position: "relative", height: "200px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}
// 		>
// 			<input {...getInputProps()} />

// 			{fileName ? (
// 				<div style={{ position: "absolute", top: "10px", left: "10px", right: "10px", bottom: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
// 					{uploadFile == "video" ? (
// 						<video controls style={{ maxWidth: "100%", maxHeight: "100%" }}>
// 							<source src={previewUrl} type="video/mp4" />
// 							Your browser does not support the video tag.
// 						</video>
// 					) : uploadFile == "audio" ? (
// 						<audio controls style={{ maxWidth: "100%" }}>
// 							<source src={previewUrl} type="audio/mp3" />
// 							Your browser does not support the audio element.
// 						</audio>
// 					) : (
// 						<img src={previewUrl} alt="Preview" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover", borderRadius: "10px" }} />
// 					)}
// 				</div>
// 			) : (
// 				<>
// 					{uploadFile == "image" && <i class="fi fi-rr-picture" style={{ fontSize: "50px" }}></i>}
// 					{uploadFile == "video" && <i class="fi fi-rr-camera-movie" style={{ fontSize: "50px" }}></i>}
// 					{uploadFile == "audio" && <i class="fi fi-rr-volume" style={{ fontSize: "50px" }}></i>}
// 					<p>Drag & drop or click to select a {uploadFile} file</p>
// 				</>
// 			)}
// 		</div>
// 	);
// };

// export default Dropzone;

import React, { useState } from "react";
import { useDropzone } from "react-dropzone";

const Dropzone = ({ onFileDrop, setError, clearErrors, uploadFile, fieldName, fileSize, fileName }) => {
	const FILE_SIZE = fileSize ? fileSize * 1000 : 5242880; // 5MB
	const SUPPORTED_FORMATS_VIDEO = { "video/mp4": [], "video/x-m4v": [], "video/*": [] };
	const SUPPORTED_FORMATS_AUDIO = { "audio/mpeg": [], "audio/wav": [], "audio/mp3": [] };
	const SUPPORTED_FORMATS_IMAGE = { "image/jpg": [], "image/jpeg": [], "image/gif": [], "image/png": [] };

	const [previewUrl, setPreviewUrl] = useState(null);

	const getAcceptedFileTypes = () => {
		switch (uploadFile) {
			case "image":
				return SUPPORTED_FORMATS_IMAGE;
			case "video":
				return SUPPORTED_FORMATS_VIDEO;
			case "audio":
				return SUPPORTED_FORMATS_AUDIO;
			default:
				return [];
		}
	};

	const onDrop = (acceptedFiles) => {
		if (acceptedFiles.length > 0) {
			const file = acceptedFiles[0];
			onFileDrop(file, uploadFile);
			clearErrors(fieldName);
			const objectUrl = URL.createObjectURL(file);
			setPreviewUrl(objectUrl);
		}
	};

	const onDropRejected = (fileRejections) => {
		const error = fileRejections[0].errors[0];

		if (error.code === "file-too-large") {
			setError(fieldName, {
				type: "manual",
				message: fileSize ? `File is larger than ${fileSize}KB.` : `File is larger than ${FILE_SIZE / 1000000}MB.`,
			});
		} else if (error.code === "file-invalid-type") {
			setError(fieldName, {
				type: "manual",
				message: error.message + ".",
			});
		}
	};

	const removeFile = () => {
		setPreviewUrl(null);
		onFileDrop(null, uploadFile);
		clearErrors(fieldName);
	};

	const { getRootProps, getInputProps } = useDropzone({
		onDrop,
		onDropRejected,
		accept: getAcceptedFileTypes(),
		maxSize: FILE_SIZE,
		multiple: false,
	});

	return (
		<div
			{...getRootProps()}
			style={{
				border: "2px solid #e0e6f7",
				position: "relative",
				height: "200px",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			}}
		>
			<input {...getInputProps()} />

			{fileName && previewUrl ? (
				<>
					<div
						style={{
							position: "absolute",
							top: "10px",
							left: "10px",
							right: "10px",
							bottom: "10px",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						{uploadFile === "video" ? (
							<video controls style={{ maxWidth: "100%", maxHeight: "100%" }}>
								<source src={previewUrl} type="video/mp4" />
								Your browser does not support the video tag.
							</video>
						) : uploadFile === "audio" ? (
							<audio controls style={{ maxWidth: "100%" }}>
								<source src={previewUrl} type="audio/mp3" />
								Your browser does not support the audio element.
							</audio>
						) : (
							<img
								src={previewUrl}
								alt="Preview"
								style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover", borderRadius: "10px" }}
							/>
						)}
					</div>

					<button
						type="button"
						onClick={(e) => {
							e.stopPropagation();
							removeFile();
						}}
						style={{
							position: "absolute",
							top: "10px",
							right: "10px",
							background: "#ff4d4f",
							color: "white",
							border: "none",
							borderRadius: "5px",
							padding: "5px 10px",
							cursor: "pointer",
						}}
					>
						Remove
					</button>
				</>
			) : (
				<>
					{uploadFile === "image" && <i className="fi fi-rr-picture" style={{ fontSize: "50px" }}></i>}
					{uploadFile === "video" && <i className="fi fi-rr-camera-movie" style={{ fontSize: "50px" }}></i>}
					{uploadFile === "audio" && <i className="fi fi-rr-volume" style={{ fontSize: "50px" }}></i>}
					<p>Drag & drop or click to select a {uploadFile} file</p>
				</>
			)}
		</div>
	);
};

export default Dropzone;

